import { Attr, HasMany, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type QuerySnippet from "./QuerySnippet";

@Model()
class QuerySnippetGroup extends ApplicationRecord {
  static jsonapiType = "query_snippet_groups";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() label: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() position: number;

  @HasMany() querySnippets: QuerySnippet[];
}

export default QuerySnippetGroup;
